import type { DropdownOption } from './dropdown-options';
import { normalizeLabel } from './dropdown-options';
import { resolveOptionClassName } from './option-class-name';

/** Fallback label when the block has no usable label prop. */
export const DEFAULT_DROPDOWN_LABEL = 'Select an option';

/** Presentational view-model shared by the dropdown block's render paths. */
export type DropdownBlockView = {
  label: string;
  displayValue: string;
  optionClassName: string;
};

/**
 * Derive the dropdown block's presentational view-model from a selected value,
 * the raw label prop, and the parsed options. Kept pure so the fallback
 * (pre-mount) and ready render paths share one source of truth instead of
 * duplicating the label/displayValue/className derivation.
 */
export function deriveDropdownBlockView(
  value: string,
  rawLabel: unknown,
  options: DropdownOption[],
): DropdownBlockView {
  const label = normalizeLabel(rawLabel) || DEFAULT_DROPDOWN_LABEL;
  const selectedOption = options.find((opt) => opt.value === value);
  const displayValue = selectedOption?.label || value || '';
  const optionClassName = resolveOptionClassName(
    selectedOption?.className,
    label,
    value,
  );
  return { label, displayValue, optionClassName };
}
